

export function resize(){
  let docEl = document.documentElement;
  let clientWidth = window.innerWidth;
  if(!clientWidth) return;
  if(clientWidth>768 ){
      clientWidth=clientWidth>1200?1200:clientWidth
    docEl.style.fontSize = 100*(clientWidth/1200) + 'px';
  }else if (clientWidth<=768) {
      clientWidth=clientWidth>750?750:clientWidth
    docEl.style.fontSize = 100*(clientWidth/750) + 'px';
  }
}
export function localLanguageVal(){
    let localLanguage='cn'
    // console.log(localStorage.getItem('sensfootLanguage')!=undefined)
    if(localStorage.getItem('sensfootLanguage')!=undefined){
        localLanguage = (localStorage.getItem('sensfootLanguage')==undefined||localStorage.getItem('sensfootLanguage')=='zh'||localStorage.getItem('sensfootLanguage')=='cn')?'cn':'en'
    }else{
        if(location.hash.indexOf("/en/")>-1){
            localLanguage='en'
        }else
        if(location.hash.indexOf("/cn/")>-1){
            localLanguage='cn'
        }
    }
    console.log(localLanguage)
    // console.log("min:"+localLanguage)
    // localStorage.removeItem("sensfootLanguage")
    if(location.hash.indexOf('/'+localLanguage+'/')<0){
        if(location.hash.indexOf("#")!==0){
            location.href=location.origin+location.pathname+location.hash.replace('/cn/','/').replace('/en/','/')+"#/"+localLanguage+"/"
        }else{
            location.href=location.origin+location.pathname+location.hash.replace('/cn/','/').replace('/en/','/').replace('#/',"#/"+localLanguage+"/")
        }
    }
    localLanguage="/"+localLanguage
    return localLanguage
}
export function IsPC() {
    var userAgentInfo = navigator.userAgent;
    var Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "BlackBerry", "iPad", "iPod");
    var flag = true;
    for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}